module.exports = __webpack_public_path__ + "static/media/logo-line-ups.c0ba008f.png";